import { createFileRoute } from '@tanstack/react-router';
import { MeLayout } from '@/app/shell/me-layout';

/** The person's shared spaces (/spaces): the app shell (the user's active organisation) around the list. */
export const Route = createFileRoute('/_auth/spaces')({
  component: MeLayout,
});
